module.exports = __webpack_public_path__ + "img/PPT版_00.6bf31bf6.png";